import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("hg_user") || "null"); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    // Try to fetch user via cookie session OR local JWT
    api.get("/auth/me").then((r) => {
      setUser(r.data);
      localStorage.setItem("hg_user", JSON.stringify(r.data));
    }).catch(() => {
      localStorage.removeItem("hg_token");
      localStorage.removeItem("hg_user");
      setUser(null);
    }).finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("hg_token", data.token);
    localStorage.setItem("hg_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };
  const signup = async (email, password, name) => {
    const { data } = await api.post("/auth/signup", { email, password, name });
    localStorage.setItem("hg_token", data.token);
    localStorage.setItem("hg_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };
  const setGoogleUser = (u) => {
    setUser(u);
    localStorage.setItem("hg_user", JSON.stringify(u));
  };
  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      // Session may already be invalid on the server; log and continue clearing local state.
      console.warn("Logout request failed", err);
    }
    localStorage.removeItem("hg_token");
    localStorage.removeItem("hg_user");
    setUser(null);
  };

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const loginWithGoogle = () => {
    const redirectUrl = window.location.origin + "/app";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, signup, logout, loginWithGoogle, setGoogleUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
